import _regeneratorRuntime from "@babel/runtime/regenerator";
import { buffers } from 'redux-saga';
import { fork, delay, actionChannel, take, cancel } from 'redux-saga/effects'; // eslint-disable-next-line import/prefer-default-export

export var throttleWithCancel = function throttleWithCancel(ms, pattern, task) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  return fork( /*#__PURE__*/_regeneratorRuntime.mark(function gen() {
    var throttleChannel, lastTask, action;
    return _regeneratorRuntime.wrap(function gen$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return actionChannel(pattern, buffers.sliding(1));

        case 2:
          throttleChannel = _context.sent;

        case 3:
          if (!true) {
            _context.next = 17;
            break;
          }

          _context.next = 6;
          return take(throttleChannel);

        case 6:
          action = _context.sent;

          if (!lastTask) {
            _context.next = 10;
            break;
          }

          _context.next = 10;
          return cancel(lastTask);

        case 10:
          _context.next = 12;
          return fork.apply(void 0, [task].concat(args, [action]));

        case 12:
          lastTask = _context.sent;
          _context.next = 15;
          return delay(ms);

        case 15:
          _context.next = 3;
          break;

        case 17:
        case "end":
          return _context.stop();
      }
    }, gen);
  }));
};
//# sourceMappingURL=saga.js.map